
export default {
  data() {
    return {
      serviceWorker: ""
    };
  },
  created() {
    this.requestPermission();
    this.$nuxt.$on("trigger-push-notification", this.triggerPushNotification);
  },
  methods: {
    triggerPushNotification(title, text, data) {
      if (!Notification) {
        alert("Desktop notifications not available in your browser!");
        return;
      } else if (Notification.permission !== "granted") {
        this.requestPermission();
      } else {
        var notification = new Notification(title, {
          body: text,
          icon: this.getChannelConstObj(data.source).img
        });

        notification.onclick = function() {
          window.open(`${window.location.origin}/v2/#/reciever/${data.id}`);
        };
      }
    },

    requestPermission() {
      if (
        window.isSecureContext &&
        Notification &&
        Notification.permission !== "granted"
      ) {
        Notification.requestPermission();
      }
    }
  },
  beforeDestroy() {
    this.$nuxt.$off("trigger-push-notification");
  }
};
